import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import LoanPropertyMultiUpdateModalUI from './LoanPropertyMultiUpdateModalUI.js'

class LoanPropertyMultiUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      rowList: [],
    }
  }

  render() {
    return (
      <LoanPropertyMultiUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        onAddClick={this.onAddClick}
        onRemoveClick={this.onRemoveClick}
        onChange={this.onChange}
        // form fields
        propertyGroup={this.props.propertyGroup}
        rowList={this.state.rowList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    if (!this.props.propertyGroup)
      return;

    let propertyGroupChanged = prevProps.propertyGroup !== this.props.propertyGroup
    let opened = this.props.updateMode && !prevProps.updateMode
    if (!propertyGroupChanged && !opened)
      return;

    let propertyGroup = this.props.propertyGroup
    let propertyList = this.props.propertyList || []
    let property = propertyList.filter(p => p.propertyCode === propertyGroup.propertyCode)[0]
    let value = property ? (property.propertyValue != null ? property.propertyValue : (property.defaultValue || '')) : ''

    let rowList = []
    if (value && String(value).trim().startsWith('[')) {
      try {
        let parsed = JSON.parse(value)
        if (Array.isArray(parsed) && parsed.length > 0) {
          rowList = parsed.map(item => {
            let row = {}
            propertyGroup.fieldList.forEach(field => {
              row[field.key] = (item && item[field.key] != null) ? String(item[field.key]) : ''
            })
            return row
          })
        }
      } catch (e) {
        // fall through to empty row
      }
    }

    if (rowList.length === 0) {
      let row = {}
      propertyGroup.fieldList.forEach(field => { row[field.key] = '' })
      rowList = [row]
    }

    this.setState({
      rowList: rowList,
      submitted: false,
      errorList: null,
    })
  }

  onChange = (index, fieldKey, event) => {
    let rowList = this.state.rowList.map((row, i) =>
      i === index ? Object.assign({}, row, { [fieldKey]: event.target.value }) : row
    )
    this.setState({ rowList: rowList })
  }

  onAddClick = (event) => {
    event.preventDefault()
    if (!this.props.propertyGroup)
      return
    let row = {}
    this.props.propertyGroup.fieldList.forEach(field => { row[field.key] = '' })
    this.setState({ rowList: this.state.rowList.concat([row]) })
  }

  onRemoveClick = (event) => {
    let index = Number(event.currentTarget.getAttribute('data-index'))
    if (this.state.rowList.length <= 1)
      return
    this.setState({ rowList: this.state.rowList.filter((row, i) => i !== index) })
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    let propertyGroup = this.props.propertyGroup
    if (!propertyGroup)
      return

    let cleanedRowList = this.state.rowList
      .map(row => {
        let next = {}
        propertyGroup.fieldList.forEach(field => {
          next[field.key] = (row[field.key] || '').trim()
        })
        return next
      })
      .filter(row => propertyGroup.fieldList.some(field => row[field.key]))

    if (cleanedRowList.length === 0) {
      this.setState({ errorList: [propertyGroup.emptyError] })
      return
    }

    let propertyValue = JSON.stringify(cleanedRowList)

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true,
      rowList: cleanedRowList,
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/properties/${propertyGroup.propertyCode}`,
      this.onSubmitCallback, {
        propertyValue: propertyValue,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false,
    })

    let propertyGroup = this.props.propertyGroup
    let property = (this.props.propertyList || [])
      .filter(p => p.propertyCode === propertyGroup.propertyCode)[0]
    if (property)
      property.propertyValue = JSON.stringify(this.state.rowList)

    this.props.onRefreshClick('noBusy')

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(LoanPropertyMultiUpdateModalSF)
